import type { Token, TokenizerExtension, TokenizerThis } from 'marked';

export interface AccordionToken {
	type: 'accordion';
	raw: string;
	label: string;
	// The label as inline tokens and the body as block tokens, so both take
	// markdown.
	labelTokens: Token[];
	tokens: Token[];
}

// A `+++ Label` line opens the block and a `+++` line alone closes it, both
// at column 0; the first closing fence ends the body, so blocks don't nest.
const ACCORDION = /^\+\+\+ +(\S[^\n]*)\n([\s\S]*?)\n\+\+\+ *(?:\n|$)/;

// A marked block extension for a collapsible section: everything between the
// fences is the body. Without a closing fence nothing matches and the
// opening line renders as plain text, so a stray `+++` cannot swallow the
// rest of the page.
export const accordionExtension: TokenizerExtension = {
	name: 'accordion',
	level: 'block',
	start: (src) => src.match(/^\+\+\+ /m)?.index,
	tokenizer(this: TokenizerThis, src): AccordionToken | undefined {
		const match = ACCORDION.exec(src);

		if (!match) {
			return undefined;
		}

		const [raw, label, body] = match;

		return {
			type: 'accordion',
			raw,
			label: label.trim(),
			labelTokens: this.lexer.inlineTokens(label.trim()),
			tokens: this.lexer.blockTokens(body)
		};
	}
};
